var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: "编辑页面信息",
            width: "950px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "顶部背景图:", prop: "bgPic" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": _vm.handleFileUpload,
                              },
                            },
                            [
                              _vm.ruleForm.bgPic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.bgPic,
                                      fit: "contain",
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "avatar_img",
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: require("@/assets/top_bg.png"),
                                    },
                                  }),
                              _vm._v(" "),
                              _vm.ruleForm.bgPic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            "宽度750，高度不限制，PNG格式图片 (默认展示白色底图)"
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "首页背景色：", prop: "bgColor" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.ruleForm.bgColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "bgColor", $$v)
                              },
                              expression: "ruleForm.bgColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.bgColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "bgColor", $$v)
                              },
                              expression: "ruleForm.bgColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("默认背景色 #F8F8F8")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.dialogVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "下拉刷新文字颜色：",
                            prop: "refreshBackgroundColor",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.ruleForm.refreshBackgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "refreshBackgroundColor",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.refreshBackgroundColor",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-color-picker", {
                                model: {
                                  value: _vm.ruleForm.refreshBackgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "refreshBackgroundColor",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.refreshBackgroundColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("默认文字色 #999598")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "顶部导航栏：", prop: "navbarStatus" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.navbarStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "navbarStatus", $$v)
                            },
                            expression: "ruleForm.navbarStatus",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不展示"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }